const getModule = {
  state: {
    selected: false,
    url: '',
    type: '',
  },
  mutations: {
    setBuyukSehirCDP(state, data) {
      if (state.type == data.type) {
        state.selected = false
        state.url = ''
        state.type = ''
      } else {
        state.selected = true
        state.url = data.url
        state.type = data.type
      }
    },
  },
  actions: {
    setBuyukSehirCDP({ commit }, data) {
      commit('setBuyukSehirCDP', data)
    },
  },
  getters: {},
}

export default getModule
